import React from "react";
import * as styles from "./Category.module.scss";
import { Link } from "gatsby";
import { motion } from "framer-motion";

const Category = ({
  name,
  img,
  href,
  colorcolor,
  categorys,
  isActive,
  colorSelected,
}) => {
  const activeStyle = {
    border: isActive ? `1px solid` : "none",
  };

  return (
    <div className={styles.category__container}>
      {isActive ? (
        <Link href={`/productos/${href}`}>
          <motion.div
            className={`${styles.category__img} ${colorSelected}`}
            style={activeStyle}
          >
            <img src={img} alt={name} />
          </motion.div>
        </Link>
      ) : (
        <Link href={`/productos/${href}`}>
          <motion.div className={styles.category__img}>
            <img src={img} alt={name} />
          </motion.div>
        </Link>
      )}

      {isActive ? (
        <Link className={styles.link} href={`/productos/${href}`}>
          <div className={styles.container_title}>
            <h6 className={colorSelected}>{name}</h6>
          </div>
        </Link>
      ) : (
        <Link className={styles.link} href={`/productos/${href}`}>
          <div className={styles.container_title}>
            <p>{name}</p>
          </div>
        </Link>
      )}
    </div>
  );
};

export default Category;
